export const membershipDuration = [
  {
    label: "1 Month",
    value: "1 Month",
  },
  {
    label: "3 Months",
    value: "3 Months",
  },
  {
    label: "6 Months",
    value: "6 Months",
  },
  {
    label: "12 Months",
    value: "12 Months",
  },
  {
    label: "2 Years",
    value: "2 Years",
  },
  {
    label: "3 Years",
    value: "3 Years",
  },
];

export const membershipPaymentMethod = [
  {
    label: "cash",
    value: "cash",
  },
  {
    label: "bank",
    value: "bank",
  },
];
